import { render, staticRenderFns } from "./PeriodPriceUpdateDialog.vue?vue&type=template&id=da883b82&scoped=true"
import script from "./PeriodPriceUpdateDialog.vue?vue&type=script&lang=js"
export * from "./PeriodPriceUpdateDialog.vue?vue&type=script&lang=js"
import style0 from "./PeriodPriceUpdateDialog.vue?vue&type=style&index=0&id=da883b82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da883b82",
  null
  
)

export default component.exports